export const aiSearchMessages = [
  'Searching thousands of products to find your ideal match...',
  'Smart sorting underway—hang tight, almost ready...',
  'Finalizing your results—prioritizing top picks and crafting clear explanations to help you choose with confidence.'
];

export const aiCompareMessages = [
  'Comparing your selected products—this won’t take long...',
  'Analyzing specs, and product information...',
  'Finalizing our analysis—making sure you have all the insights you need!'
];

export const aiRecommendMessages = [
  'Analyzing your scenario to pinpoint the perfect recommendations...',
  'Reasoning the best solution tailored to your specific use case...',
  'Finalizing your personalized recommendation analysis—almost ready!'
];

export const creatingSalesEnablementMessages = [
  'Creating tailored sales enablement materials for your product...',
  'Crafting compelling content designed to empower your sales efforts...',
  'Finalizing persuasive assets you can use immediately!'
];

export const loadingSalesEnablementMessages = [
  'Loading tailored sales enablement materials for your product...',
  'Generating compelling content to empower your sales efforts — please wait...',
  'Preparing persuasive assets for your sales toolkit — almost ready!'
];

export const aiPdfProcessingMessages = [
  'Analyzing your PDF—extracting key content and insights...',
  'Parsing document structure and identifying important sections...',
  'Finalizing document understanding—getting ready to present results!'
];

export const aiProductChatMessages = [
  'Reviewing your message—pinpointing product-related queries and goals...',
  'Connecting the dots—cross-referencing features, specs, and value propositions...',
  'Generating insights and recommendations tailored to your product conversation...'
];
